import Error400 from "../Pages/OtherPages/Error/Error400/Error400";
import Error401 from "../Pages/OtherPages/Error/Error401/Error401";
import Error403 from "../Pages/OtherPages/Error/Error403/Error403";
import Error404 from "../Pages/OtherPages/Error/Error404/Error404";
import Error500 from "../Pages/OtherPages/Error/Error500/Error500";
import Error503 from "../Pages/OtherPages/Error/Error503/Error503";
import LoginSimple from "../Pages/OtherPages/Authentication/LoginSimple/LoginSimple";
import ForgetPassword from "../Pages/OtherPages/Authentication/ForgetPassword/ForgetPassword";
import VerifyCode from "../Pages/OtherPages/Authentication/VerifyCode/VerifyCode";
import ResetPassword from "../Pages/OtherPages/Authentication/ResetPassword/ResetPassword";


export const authRoutes = [
  //Error
  { path: `${process.env.PUBLIC_URL}/errors/error400`, Component: <Error400 /> },
  { path: `${process.env.PUBLIC_URL}/errors/error401`, Component: <Error401 /> },
  { path: `${process.env.PUBLIC_URL}/errors/error403`, Component: <Error403 /> },
  { path: `${process.env.PUBLIC_URL}/errors/error404`, Component: <Error404 /> },
  { path: `${process.env.PUBLIC_URL}/errors/error500`, Component: <Error500 /> },
  { path: `${process.env.PUBLIC_URL}/errors/error503`, Component: <Error503 /> },

  // Auth Pages
  { path: `${process.env.PUBLIC_URL}/authentication/loginsimple`, Component: <LoginSimple /> },
  { path: `${process.env.PUBLIC_URL}/authentication/forgetpassword`, Component: <ForgetPassword /> },
  { path: `${process.env.PUBLIC_URL}/authentication/verify-code`, Component: <VerifyCode /> },
  { path: `${process.env.PUBLIC_URL}/authentication/reset-password`, Component: <ResetPassword /> },
];
